import type { FC } from "react";
import SVGIcon from "@ch/components/Icons/SVGIcon";

const CloseIcon: FC<{
  width?: number | string;
  height?: number | string;
  color?: string;
}> = ({ width = 24, height = 24, color = "currentColor" }) => {
  return (
    <SVGIcon color={color} height={height} viewBox="0 0 24 24" width={width}>
      <path
        d="M18 6L6 18M6 6l12 12"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </SVGIcon>
  );
};

export default CloseIcon;
